import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import * as S from './LeverageTableSkeleton.styles';
import { SKELETON_BASE_COLOR, SKELETON_HIGHLIGHT_COLOR } from './constants';

const SKELETON_ROWS = 10;

export function LeverageTableSkeleton() {
  return (
    <S.Wrapper>
      <S.TableContainer>
        {/* 테이블 헤더 */}
        <S.TableHeader>
          <Skeleton
            width={50}
            height={20}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
          />
          <Skeleton
            width={150}
            height={20}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
          />
          <Skeleton
            width={120}
            height={20}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
          />
          <Skeleton
            width={180}
            height={20}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
          />
          <Skeleton
            width={150}
            height={20}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
          />
        </S.TableHeader>

        {/* 테이블 행 */}
        {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
          <S.TableRow key={index}>
            {/* Tier */}
            <Skeleton
              width={30}
              height={20}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
            />
            {/* Position Bracket */}
            <Skeleton
              width={280}
              height={20}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
            />
            {/* Max Leverage */}
            <Skeleton
              width={80}
              height={20}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
            />
            {/* Maintenance Margin Rate */}
            <Skeleton
              width={100}
              height={20}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
            />
            {/* Maintenance Amount */}
            <Skeleton
              width={120}
              height={20}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
            />
          </S.TableRow>
        ))}
      </S.TableContainer>
    </S.Wrapper>
  );
}
